/**
 * @copyright Stadtbauer
 * @description Stadtbauer home page
 */

import './../css/style.scss';
import 'bootstrap';
import $ from 'jquery';

import './news';

// Closes responsive menu when a scroll trigger link is clicked
$('.js-scroll-trigger').click(() => {
  $('.navbar-collapse').collapse('hide');
});

// Activate scrollspy to add active class to navbar items on scroll
$('body').scrollspy({
  target: '#mainNav',
  offset: 56
});

// load images lazy
$("img[data-lazysrc]").each(function() {
  $(this).attr("src", $(this).attr("data-lazysrc"));
});

// copy contact information
$('#copyContact').tooltip({ trigger: 'manual', delay: 500 });

$('#copyContact').click(async() => {
  const clipboardValue = Array.from(document.querySelectorAll('.contact-card .contact-value')).map(value => value.innerText).join('\n');
  navigator.clipboard.writeText(clipboardValue).then(() => {
    $('#copyContact').tooltip('show');
    setTimeout(() => {
      $('#copyContact').tooltip('hide');
    }, 1000);
  }, err => {
    console.error('Async: Could not copy text: ', err);
  });
});

// set business hours
const weekday = new Array('Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag');
const label = document.getElementById('buinesshours-label');
const times = (() => {
  const openTimes = {};
  document.querySelectorAll('.businesshours-group .businesshours-item').forEach(item => {
    const day = item.querySelector('.businesshours-key').innerText.replace(':', '').trim();
    const time = item.querySelector('.businesshours-value').innerText.replace('Uhr', '').trim();
    if (time.match(/[0-9:]+[ ]*-[ ]*[0-9:]+([ ]*Uhr)?/)) openTimes[day] = time;
  });
  return openTimes;
})();

const updateBusinessLabel = () => {
  const date = new Date();
  if (times[weekday[date.getDay()]]) {
    const start = times[weekday[date.getDay()]].split('-')[0].replace(':', '').trim();
    const end = times[weekday[date.getDay()]].split('-')[1].replace(':', '').trim();
    const check = `${date.getHours()}${date.getMinutes()}`;
    if (check >= start && check <= end) {
      label.innerText = 'Geöffnet';
      label.classList.add('btn-success');
      label.classList.remove('btn-danger');
      label.classList.remove('btn-light');
    } else {
      label.innerText = 'Geschlossen';
      label.classList.add('btn-danger');
      label.classList.remove('btn-success');
      label.classList.remove('btn-light');
    }
  } else {
    label.innerText = 'Geschlossen';
    label.classList.add('btn-danger');
    label.classList.remove('btn-success');
    label.classList.remove('btn-light');
  }
};

// update ones and then enable interval
updateBusinessLabel();
setInterval(() => {
  updateBusinessLabel();
}, 60 * 1000);